import { Block } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const MemeContainer = styled(Block)`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-top: 100%;
  box-sizing: border-box;
`
